import {Popconfirm} from 'antd'
import {getId, getType} from 'apis/model/base'
import classNames from 'classnames'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import {UseHook} from 'components/UseHook'
import {ROOT_URL} from 'envs/_current/config'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {BsEnvelopeFill} from 'react-icons/bs'
import {RxEnter, RxExit} from 'react-icons/rx'
import {useJoinAction} from 'views/AppLocals/factory/createStatusBar'
import ServerContext from 'views/Server/ServerContext'
import {NullAsDefault} from 'views/Shared'
import {EventActionTypes} from '..'
import {formatDate} from "../../../../helpers/datetimeHelpers";
import dayjs from "dayjs";

export const CalendarAvatar = ({time, color}) => {
    const {isSm} = useContext(LayoutContext)
    const dt = dayjs(time).isValid() ? dayjs(time) : dayjs()

    const LeftPattern = () => (
        <div
            style={{
                position: 'absolute',
                width: '8px',
                height: isSm ? 11 : 14,
                top: '-5px',
                left: isSm ? 16 : 18,
                borderTopLeftRadius: '3px',
                borderTopRightRadius: '3px',
                borderBottomLeftRadius: '10px',
                borderBottomRightRadius: '10px',
                backgroundColor: color || '#215f3f',
                // opacity: 0.75,
            }}
        />
    )

    const RightPattern = () => (
        <div
            style={{
                position: 'absolute',
                width: '8px',
                height: isSm ? 11 : 14,
                top: '-5px',
                right: isSm ? 16 : 18,
                borderTopLeftRadius: '3px',
                borderTopRightRadius: '3px',
                borderBottomLeftRadius: '10px',
                borderBottomRightRadius: '10px',
                backgroundColor: color || '#215f3f',
                // opacity: 0.75,
            }}
        />
    )

    var month = dt.format('MMM')
    var day = dt.format('DD')

    return (
        <div
            style={{
                zIndex: 1,
                width: isSm ? 80 : 100,
                height: isSm ? 80 : 100,
                boxShadow: '0px 6px 10px 2px rgb(0 0 0 / 15%)',
                borderRadius: '0.75rem',
            }}
            className="flex flex-col flex-center gap-2 bg-indigo-600 p-2 relative">
            <LeftPattern/>
            <RightPattern/>
            <div className="flex flex-center font-bold text-xs md:text-lg text-white uppercase">
                {month}
            </div>
            <div
                style={{width: '90%', lineHeight: 1.4}}
                className="flex flex-center rounded-lg font-bold text-xl md:text-2xl text-indigo-600 bg-white tracking-wide">
                {day}
            </div>
        </div>
    )
}

const EventBanner = React.memo(({Wrapper = 'div'}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)

    const {item: event, handleActionClick = NullAsDefault} = useContext(ServerContext)

    const [id, type] = [getId(event), getType(event)]

    const cover_photo =
        _.get(event, 'cover_photo') ?? `${ROOT_URL}/images/default/event-bg.jpg`

    const {time_open, time_close, is_expired} = event ?? {}

    return (
        <Wrapper className="flex flex-col">
            <div className="w-full bg-green-700">
                <div className="container mx-auto px-4 md:px-5 py-4 flex items-start gap-2 md:gap-3">
                    <CalendarAvatar time={time_open}/>
                    <div className="flex flex-col flex-1 mt-0 md:mt-1">
                        <h1 className="text-normal md:text-2xl font-bold text-white max-lines-1">
                            {getTitle(event)}
                        </h1>
                        <div
                            className="flex flex-col md:flex-row gap-x-2 uppercase text-xs text-white opacity-75 font-medium tracking-wide">
              <span className="leading-tight md:leading-normal">
                <span className="font-normal capitalize italic opacity-50 mr-2">
                  {t('from')}
                </span>
                  {formatDate(time_open, 'hh:mm a - Do MMMM, YYYY')}
              </span>
                            {time_close && (
                                <span className="leading-tight md:leading-normal">
                  <span className="font-normal lowercase italic opacity-50 mr-2">
                    {t('to')}
                  </span>
                                    {formatDate(time_close, 'hh:mm a - Do MMMM, YYYY')}
                </span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-green-700 h-4 mt-2"/>
            <div
                style={{
                    width: isSm ? 'calc(100% - 1rem)' : '100%',
                    minHeight: isSm ? '8rem' : '16rem',
                    maxHeight: '20rem',
                    marginTop: isSm ? '-4rem' : '-4.5rem',
                    backgroundImage: `url(${cover_photo})`,
                    backgroundSize: 'cover',
                    backgroundPosition: '50% 50%',
                }}
                className="container mx-auto rounded-lg shadow-md"
            />
            <div className="container mx-auto p-2 mt-2">
                <div className="background-200 rounded-md px-3 py-2">
                    <div className="flex flex-col md:flex-row gap-1 md:gap-3">
                        <div className="flex-1 truncate font-medium text-sm text-color-200 italic">
                            {t('do you want to join this event')}
                        </div>
                        <div className="flex items-center justify-end gap-3">
                            <div
                                onClick={() => {
                                    handleActionClick(EventActionTypes.INVITE)
                                }}
                                style={{
                                    padding: '2px 10px',
                                    fontStyle: 'italic',
                                    fontWeight: 500,
                                    borderRadius: 5,
                                }}
                                className="flex flex-center border border-primary text-xs text-primary hover:text-white background hover:bg-primary cursor-pointer">
                                <BsEnvelopeFill className="mr-2"/>
                                {t('invite')}
                            </div>
                            <UseHook
                                hook={useJoinAction}
                                initialValue={{
                                    id,
                                    type,
                                    joined_status: event?.joined_status,
                                }}>
                                {({joined_status, toggle = NullAsDefault}) => (
                                    <Popconfirm
                                        title={
                                            <div className="font-medium text-sm text-color-100 italic">
                                                {t(
                                                    joined_status
                                                        ? 'do you want to leave this event'
                                                        : 'do you want to join this event'
                                                )}
                                            </div>
                                        }
                                        placement="topRight"
                                        okText={t('confirm')}
                                        cancelText={t('cancel')}
                                        okButtonProps={{
                                            type: 'primary',
                                            className:
                                                'button-rounded-md no-border text-xs font-medium px-3',
                                        }}
                                        cancelButtonProps={{
                                            className:
                                                'button-rounded-md no-border text-xs font-medium px-3',
                                        }}
                                        onConfirm={toggle}>
                                        <div
                                            style={{
                                                padding: '2px 10px',
                                                fontStyle: 'italic',
                                                fontWeight: 500,
                                                borderRadius: 5,
                                            }}
                                            className={classNames(
                                                'flex flex-center text-xs cursor-pointer',
                                                joined_status
                                                    ? 'border background-100 text-color-300 hover:text-color-100'
                                                    : 'border border-primary bg-primary text-white'
                                            )}>
                                            {joined_status ? (
                                                <RxExit className="mr-2"/>
                                            ) : (
                                                <RxEnter className="mr-2"/>
                                            )}
                                            {t(joined_status ? 'leave' : 'join')}
                                        </div>
                                    </Popconfirm>
                                )}
                            </UseHook>
                        </div>
                    </div>
                </div>
            </div>
        </Wrapper>
    )
})

export default EventBanner
